import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
export function CTASection() {
  return <section className="py-24 relative overflow-hidden" data-id="element-11">
      <div className="absolute inset-0 bg-gradient-to-r from-[#2D5A3D] to-[#1A3A25]" data-id="element-12"></div>

      {/* Decorative Patterns */}
      <div className="absolute inset-0 opacity-10" data-id="element-13">
        <svg className="w-full h-full" viewBox="0 0 100 100" preserveAspectRatio="none" data-id="element-14">
          <path d="M0 100 C 20 0 50 0 100 100 Z" fill="white" data-id="element-15" />
        </svg>
      </div>

      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10 text-center" data-id="element-16">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-17">
          <h2 className="text-3xl md:text-5xl font-serif font-bold text-white mb-6" data-id="element-18">
            准备好开始您的舒适之旅了吗？
          </h2>
          <p className="text-[#FDF8F0]/80 text-lg md:text-xl mb-10 max-w-2xl mx-auto" data-id="element-19">
            加入50,000+用户的选择，体验新加坡最专业的按摩服务。
            <br className="hidden md:block" data-id="element-20" />
            Ready to start your journey of relaxation?
          </p>

          <button className="bg-[#C9A96E] hover:bg-[#b89a60] text-[#1A1A1A] px-10 py-4 rounded-full text-lg font-bold transition-all duration-300 shadow-lg hover:shadow-xl hover:-translate-y-1 inline-flex items-center" data-id="element-21">
            立即预约 (Book Now)
            <ArrowRight className="ml-2 w-5 h-5" data-id="element-22" />
          </button>
        </motion.div>
      </div>
    </section>;
}